import ShortLogoPNG from './short_logo.png'
import ShortLogoSVG from './short_logo.svg'
import LongLogoPNG from './long_logo.png'
import LongLogoSVG from './long_logo.svg'
import LongT4TPNG from './long_t4t.png'

export default {
    ShortLogoPNG,
    ShortLogoSVG,
    LongLogoPNG,
    LongLogoSVG,
    LongT4TPNG
}